import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

const VideoPlayerOverlay = ({ handleVideoPlay, element,showOverlay =false, thumbnailSrc }) => {
    return (
        <div className="border-white border relative" style={{ height: '43vh' }} onMouseEnter={() => handleVideoPlay(element, 'play')}
            onMouseLeave={() => handleVideoPlay(element, 'pause')}>
            {
                showOverlay && <img
                    className="object-fit object-top"
                    src={thumbnailSrc}
                    alt=""
                />
            }
        </div>
    )
};

export default VideoPlayerOverlay;